export const PrintHeader = ({ title, subtitle }) => (
  <div className="hidden print:flex items-center gap-4 pb-4 mb-6 border-b-2" style={{ borderColor: "#D4333B" }} data-testid="print-header">
    <img src="/brand/ep-group-dark.png" alt="EP Group" className="h-10 w-auto" />
    <div className="flex-1">
      <p className="font-display text-lg font-bold" style={{ color: "#0F172A" }}>Warehouse Activity Monitor</p>
      <p className="text-xs" style={{ color: "#475569" }}>{title}{subtitle ? ` · ${subtitle}` : ""}</p>
    </div>
    <p className="text-[10px] text-right" style={{ color: "#64748B" }}>Printed {new Date().toLocaleString()}<br />EP Group · Confidential</p>
  </div>
);
